import React, { useState } from 'react';
import { observer } from 'mobx-react';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { FeatureToggle } from 'stores/ToggleStore';
import { ActionIcon, DownArrowIcon, RightArrowIcon } from 'components/Icon';
import { Link } from 'react-router-dom';

import { FeatureBoundedToggleCreator } from './FeatureBoundedToggleCreator';
import { ToggleList } from './ToggleList';

interface Props
{
  featureToggle: FeatureToggle,
}

export const FeatureToggleView: React.FC<Props> = observer(({featureToggle}) =>
{
  const { uiStore } = useStore();

  const [toggleTreeOpened, setToggleTreeOpened] = useState(false);
  const toggleTreeSwitchHandler = () => setToggleTreeOpened(prev => !prev);

  return (
    <div className={['feature-toggles', toggleTreeOpened ? '' : 'closed'].join(' ')}>
      <div className="feature">
        <div className="feature-title">
          <ActionIcon action={toggleTreeSwitchHandler}>{toggleTreeOpened ? <DownArrowIcon /> : <RightArrowIcon />}</ActionIcon>
          <Link title={uiStore.labels.pages.features.viewDetailsOfFeature.apply({featureName: featureToggle.name})}
                to={{pathname: paths.buildFeatureViewPath(featureToggle.token || ''), state: { isCancelRequired: true }}}>
            {featureToggle.name}
          </Link>
        </div>
        <FeatureBoundedToggleCreator featureId={featureToggle.id || 0} />
      </div>
      <ToggleList featureToggle={featureToggle} currentScope="/" isToggleOn={undefined} />
    </div>
  );
});